import React, { useState, useEffect, Fragment } from "react";
import Select from "react-select";
import _ from "lodash";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import Firebase from "../../../firebasehelper";
import { LayerTypes } from "../../../Constants/brand";
import { default_chatbot } from "../constants/default";
import { conciergeTypes } from "../constants/selections";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import "./BotContent.css";

const UPLOADING_VIDEO = "Uploading video";
const UPLOADING_IMAGE = "Uploading image...";

const BotContent = ({ onChangeChatBot, isVisible }) => {
  const [chatbot, setChatBot] = useState(default_chatbot.data);
  const [uploader, setUploadTask] = useState('');
  const [layerIndex, setLayerIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  useEffect(() => {
    onChangeChatBot(chatbot);
  }, [chatbot]);
  const handleInputChange = ({ target }) => {
    const { name, value } = target;
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot[name] = value;
    setChatBot(newChatbot);
  };
  const handleSelectTopic = (value) => {
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["topic"] = value.value;
    setChatBot(newChatbot);
  };
  const handleLayerChange = (index, key, value) => {
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index][key] = value;
    setChatBot(newChatbot);
  };

  const handleAnswerChange = (index, answer_index, value) => {
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index].answers[answer_index] = value;
    setChatBot(newChatbot);
  };

  const addNewCommunicationLayer = () => {
    const newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"].push({ type: "", statement: "" });
    setChatBot(newChatbot);
  };
  const addAnswer = (index) => {
    let newChatbot = _.cloneDeep(chatbot);
    if (!newChatbot["communicationLayers"][index].answers)
      newChatbot["communicationLayers"][index].answers = [""];
    else newChatbot["communicationLayers"][index].answers.push("");
    setChatBot(newChatbot);
  };
  const removeAnswer = (index, answer_index) => {
    let newChatbot = _.cloneDeep(chatbot);
    newChatbot["communicationLayers"][index].answers.splice(answer_index, 1);
    setChatBot(newChatbot);
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };

  const handleDownloadURL = () => {
    uploader.snapshot.ref.getDownloadURL().then((downloadURL) => {
      setLoading(false);
      setLoadingScript("");
      handleLayerChange(layerIndex, "media_url", downloadURL);
    });
  };
  const uploadContent = async (
    contentType,
    mediaContent,
    communicationLayerIndex,
    title
  ) => {
    let uploadFolder = "concierge_bots";
    if (contentType === IMAGE_UPLOAD || contentType === GIF_UPLOAD) {
      setLoading(true);
      setLoadingScript(UPLOADING_IMAGE);
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      setLoading(false);
      handleLayerChange(communicationLayerIndex, "media_url", img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      setLoading(true);
      setLoadingScript(UPLOADING_VIDEO);
      uploadTask.on(
        "state_changed",
        handleUploadProgress,
        handleUploadError,
        ()=>{
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            setLoading(false);
            setLoadingScript("");
            handleLayerChange(communicationLayerIndex, "media_url", downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      handleLayerChange(communicationLayerIndex, "media_url", mediaContent);
    }
  };
  return (
    <div
      className={`${!isVisible ? "d-none" : ""}`}
      style={{ textAlign: "left", width: "100%" }}
    >
      <h5 className="section-title">Topic</h5>
      <div className="input-container mb-2">
        <Select
          value={
            chatbot.topic
              ? { value: chatbot.topic, label: chatbot.topic }
              : null
          }
          onChange={handleSelectTopic}
          placeholder="Select a topic"
          options={conciergeTypes.map((obj) => ({
            value: obj,
            label: obj,
          }))}
        />
      </div>

      <React.Fragment>
        <h5 className="section-title">Chatbot welcome message</h5>
        <textarea
          name="welcomeText"
          className="form-control form-control-md mb-2"
          placeholder="Welcome message"
          value={chatbot.welcomeText}
          onChange={handleInputChange}
        />
      </React.Fragment>

      <React.Fragment>
        {chatbot.communicationLayers.map((layer, index) => (
          <React.Fragment key={index}>
            <div className="section-title">
              <h5>Add Communication Layer</h5>
              <p>{index + 1}</p>
            </div>
            <div className="input-container mb-2">
              <Select
                value={
                  chatbot.communicationLayers[index].type
                    ? {
                        label: chatbot.communicationLayers[index].type,
                        value: chatbot.communicationLayers[index].type,
                      }
                    : null
                }
                onChange={(value) =>
                  handleLayerChange(index, "type", value.value)
                }
                placeholder="Select a layer type"
                options={LayerTypes}
              />
            </div>
            {chatbot.communicationLayers[index].type && (
              <div className="input-container mb-2">
                {chatbot.communicationLayers[index].type === YOUTUBE_URL && (
                  <YoutubeInput
                    onChangeContent={(content) =>
                      uploadContent(
                        chatbot.communicationLayers[index].type,
                        content,
                        index,
                        chatbot.communicationLayers[index].statement
                      )
                    }
                  />
                )}
                {chatbot.communicationLayers[index].type === IMAGE_UPLOAD && (
                  <ImageUpload
                    onChangeContent={(content) =>
                      uploadContent(
                        chatbot.communicationLayers[index].type,
                        content,
                        index,
                        chatbot.communicationLayers[index].statement
                      )
                    }
                  />
                )}
                {chatbot.communicationLayers[index].type === GIF_UPLOAD && (
                  <ImageUpload
                    isGif={true}
                    onChangeContent={(content) =>
                      uploadContent(
                        chatbot.communicationLayers[index].type,
                        content,
                        index,
                        chatbot.communicationLayers[index].statement
                      )
                    }
                  />
                )}
                {chatbot.communicationLayers[index].type === VIDEO_UPLOAD && (
                  <VideoUpload
                    onChangeContent={(content) =>
                      uploadContent(
                        chatbot.communicationLayers[index].type,
                        content,
                        index,
                        chatbot.communicationLayers[index].statement
                      )
                    }
                  />
                )}
              </div>
            )}
            {["Statement", "Question", "Statement agreeableness"].find(
              (c) => c === chatbot.communicationLayers[index].type
            ) && (
              <React.Fragment>
                <div className="section-title">
                  <h5 className="section-title">
                    {chatbot.communicationLayers[index].type}
                  </h5>
                  <p>{index + 1}</p>
                </div>
                <input
                  name="statement"
                  className="form-control form-control-md mb-4"
                  value={chatbot.communicationLayers[index].statement}
                  onChange={({ target }) =>
                    handleLayerChange(index, "statement", target.value)
                  }
                  autoComplete="off"
                />
              </React.Fragment>
            )}
            {chatbot.communicationLayers[index].type === "Polls" && (
              <React.Fragment>
                <div className="section-title">
                  <h5 className="section-title">
                    {chatbot.communicationLayers[index].type}
                  </h5>
                  <p>{index + 1}</p>
                </div>
                <input
                  name="statement"
                  placeholder="Polls Question"
                  className="form-control form-control-md mb-2"
                  value={chatbot.communicationLayers[index].statement}
                  onChange={({ target }) =>
                    handleLayerChange(index, "statement", target.value)
                  }
                  autoComplete="off"
                />
                {chatbot.communicationLayers[index].answers &&
                  chatbot.communicationLayers[index].answers.map(
                    (answer, answer_index) => (
                      <div className="polls-answer" key={answer_index}>
                        <input
                          placeholder="Answer"
                          className="form-control form-control-md mt-2 mb-2"
                          value={
                            chatbot.communicationLayers[index].answers
                              ? chatbot.communicationLayers[index].answers[
                                  answer_index
                                ]
                              : ""
                          }
                          onChange={({ target }) =>
                            handleAnswerChange(
                              index,
                              answer_index,
                              target.value
                            )
                          }
                          autoComplete="off"
                        />
                        <button
                          onClick={() => removeAnswer(index, answer_index)}
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    )
                  )}
                <button
                  className={`btn btn-orange mr-1`}
                  type="button"
                  onClick={() => addAnswer(index)}
                >
                  Add new answer
                </button>
              </React.Fragment>
            )}
          </React.Fragment>
        ))}
      </React.Fragment>
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? "800ms" : "0ms",
        }}
        unmountOnExit
      >
        <Fragment>
          <p>{loading_script}</p>
          <CircularProgress />
        </Fragment>
      </Fade>
      {!loading && (
        <button
          className={`btn btn-green`}
          type="button"
          onClick={addNewCommunicationLayer}
        >
          Add new communication layer
        </button>
      )}
    </div>
  );
};

export default BotContent;



// WEBPACK FOOTER //
// ./src/screens/AutoConcierge/components/BotContent.js